var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-snackbar',{attrs:{"top":_vm.top,"left":_vm.left,"color":_vm.color,"multi-line":_vm.mode === 'multi-line',"timeout":_vm.timeout,"vertical":_vm.mode === 'vertical'},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }